"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var difference_1 = tslib_1.__importDefault(require("lodash/difference"));
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var layout_1 = require("../facade/layout");
var section_1 = require("./section");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
/**
 * @alpha
 */
var DashboardLayoutBuilder = /** @class */ (function () {
    function DashboardLayoutBuilder(layoutFacade, layoutFacadeConstructor) {
        this.layoutFacade = layoutFacade;
        this.layoutFacadeConstructor = layoutFacadeConstructor;
    }
    /**
     * Creates an instance of DashboardLayoutBuilder for particular layout.
     *
     * @param layout - layout to modify
     */
    DashboardLayoutBuilder.for = function (layout) {
        ts_invariant_1.default(sdk_backend_spi_1.isDashboardLayout(layout), "Provided data must be IDashboardLayout!");
        return new DashboardLayoutBuilder(layout_1.DashboardLayoutFacade.for(layout), layout_1.DashboardLayoutFacade.for);
    };
    /**
     * Creates an instance of DashboardLayoutBuilder with empty layout.
     */
    DashboardLayoutBuilder.forNewLayout = function () {
        var emptyLayout = {
            type: "IDashboardLayout",
            sections: [],
        };
        return DashboardLayoutBuilder.for(emptyLayout);
    };
    DashboardLayoutBuilder.prototype.size = function (valueOrUpdateCallback) {
        var _this = this;
        return this.setLayout(function (layout) { return (tslib_1.__assign(tslib_1.__assign({}, layout), { size: sdk_backend_base_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, _this.facade().size()) })); });
    };
    DashboardLayoutBuilder.prototype.addSection = function (create, index) {
        if (create === void 0) { create = identity_1.default; }
        if (index === void 0) { index = this.facade().sections().count(); }
        var emptySection = {
            type: "IDashboardLayoutSection",
            items: [],
        };
        this.setLayout(function (layout) {
            var updatedRows = tslib_1.__spreadArrays(layout.sections);
            updatedRows.splice(index, 0, emptySection);
            return tslib_1.__assign(tslib_1.__assign({}, layout), { sections: updatedRows });
        });
        section_1.DashboardLayoutSectionBuilder.for(this, index).modify(create);
        return this;
    };
    DashboardLayoutBuilder.prototype.modifySection = function (index, modify) {
        var sectionFacade = this.facade().sections().section(index);
        ts_invariant_1.default(sectionFacade, "Cannot modify the section - section at index " + index + " does not exist!");
        section_1.DashboardLayoutSectionBuilder.for(this, index).modify(modify);
        return this;
    };
    DashboardLayoutBuilder.prototype.removeSection = function (index) {
        var sectionFacade = this.facade().sections().section(index);
        ts_invariant_1.default(sectionFacade, "Cannot remove the section - section at index " + index + " does not exist!");
        return this.setLayout(function (layout) {
            var updatedRows = tslib_1.__spreadArrays(layout.sections);
            updatedRows.splice(index, 1);
            return tslib_1.__assign(tslib_1.__assign({}, layout), { sections: updatedRows });
        });
    };
    DashboardLayoutBuilder.prototype.moveSection = function (fromIndex, toIndex) {
        var _a;
        var section = (_a = this.facade().sections().section(fromIndex)) === null || _a === void 0 ? void 0 : _a.raw();
        ts_invariant_1.default(section, "Cannot move the section - section at index " + fromIndex + " does not exist!");
        var maxToIndex = Math.min(toIndex, this.facade().sections().count() - 1);
        this.removeSection(fromIndex);
        this.addSection(function (r) {
            return r.setSection(section);
        }, maxToIndex);
        return this;
    };
    DashboardLayoutBuilder.prototype.removeSections = function (selector) {
        if (selector === void 0) { selector = function (sections) { return sections.all(); }; }
        var sectionsToRemove = selector(this.facade().sections());
        if (isArray_1.default(sectionsToRemove)) {
            this.setLayout(function (layout) {
                var updatedRows = difference_1.default(layout.sections, sectionsToRemove.map(function (r) { return r.raw(); }));
                return tslib_1.__assign(tslib_1.__assign({}, layout), { sections: updatedRows });
            });
        }
        else if (sectionsToRemove) {
            this.removeSection(sectionsToRemove.index());
        }
        return this;
    };
    DashboardLayoutBuilder.prototype.removeEmptySections = function () {
        return this.removeSections(function (sections) { return sections.filter(function (section) { return section.isEmpty(); }); });
    };
    DashboardLayoutBuilder.prototype.modifySections = function (modify, selector) {
        var _this = this;
        if (selector === void 0) { selector = function (sections) { return sections.all(); }; }
        var sectionsToModify = selector(this.facade().sections());
        if (isArray_1.default(sectionsToModify)) {
            sectionsToModify.forEach(function (section) {
                _this.modifySection(section.index(), modify);
            });
        }
        else if (sectionsToModify) {
            this.modifySection(sectionsToModify.index(), modify);
        }
        return this;
    };
    DashboardLayoutBuilder.prototype.setLayout = function (valueOrUpdateCallback) {
        var updatedLayout = sdk_backend_base_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, this.build());
        this.layoutFacade = this.layoutFacadeConstructor(updatedLayout);
        return this;
    };
    DashboardLayoutBuilder.prototype.facade = function () {
        return this.layoutFacade;
    };
    DashboardLayoutBuilder.prototype.modify = function (modifications) {
        modifications(this, this.facade());
        return this;
    };
    DashboardLayoutBuilder.prototype.build = function () {
        return this.layoutFacade.raw();
    };
    return DashboardLayoutBuilder;
}());
exports.DashboardLayoutBuilder = DashboardLayoutBuilder;
//# sourceMappingURL=layout.js.map